/**
 * Cookie that remembers the player preferences (DI, cab, amp per instrument).
 *
 * Lives in a plain module, not in `PlayerConfigContext` ('use client'): a
 * server component importing a value from a client module gets a client
 * reference stub, not the string, so `cookies().get(KEY)` silently misses.
 */
export const PLAYER_CONFIG_KEY = 'player-config-v1';
